import { render, staticRenderFns } from "./LoginLayout.vue?vue&type=template&id=995b93d6&scoped=true&functional=true"
var script = {}
import style0 from "./LoginLayout.vue?vue&type=style&index=0&id=995b93d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "995b93d6",
  null
  
)

export default component.exports